import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Api from "../../../shared/api/api";
import "../admin/styles/AdminBookstores.css";
import "../admin/styles/AdminOutreach.css";
const categories = ["Book Clubs", "Book Reviewers", "Podcasts", "Author Interviews", "Libraries & Bookstores"];
export default function CollaborationPage() {
  const [value, setValue] = useState({
      name: "",
      email: "",
      category: "",
      organization: "",
      website: "",
      genres: "",
      message: "",
      company_website: "",
      consent: false
    }),
    [busy, setBusy] = useState(false),
    [error, setError] = useState(""),
    [success, setSuccess] = useState("");
  useEffect(() => {
    const old = document.title;
    document.title = "Collaborate with Kenneth L. Powell | Avwakin Publishing";
    return () => {
      document.title = old;
    };
  }, []);
  const change = e => setValue({
    ...value,
    [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value
  });
  return <article className="bookstore-page outreach-page"><header><h1>Let's talk books and storytelling</h1><p>Connect with Kenneth L. Powell and Avwakin Publishing.</p></header><p>Interested in reviewing a book, selecting a book club read, arranging a podcast conversation, appearing as an author interview guest, or hosting a library or bookstore event? We'd love to hear about your interests.</p><p>We value thoughtful conversations and honest, independent reader feedback. Review copies and interview invitations depend on fit and availability; applying does not guarantee either. A complimentary copy is never conditional on a review or favorable rating.</p>
 {success ? <p role="status" className="bookstore-notice">{success}</p> : <form className="outreach-workspace" onSubmit={async e => {
      e.preventDefault();
      setBusy(true);
      setError("");
      try {
        const r = await Api.request("api/outreach-public/applications", value, "post");
        setSuccess(r.message);
      } catch (err) {
        setError(err.message);
      } finally {
        setBusy(false);
      }
    }}><fieldset className="outreach-workspace" disabled={busy}><div className="bookstore-fields">{[["name", "Your name", "text", true], ["email", "Email address", "email", true], ["organization", "Organization / platform", "text", false], ["website", "Website / public profile", "url", false], ["genres", "Genres / topics", "text", false]].map(([name, title, type, required]) => <label key={name}>{title}<input name={name} type={type} required={required} value={value[name]} onChange={change} maxLength={name === "website" ? 1000 : 255} /></label>)}<label>Collaboration interest<select name="category" required value={value.category} onChange={change}><option value="">Choose an interest…</option>{categories.map(c => <option key={c}>{c}</option>)}</select></label></div><label>Tell us about your idea<textarea name="message" required maxLength={8000} rows={7} value={value.message} onChange={change} /></label><div style={{
          display: "none"
        }} aria-hidden="true"><label>Leave this field empty<input name="company_website" tabIndex={-1} autoComplete="off" value={value.company_website} onChange={change} /></label></div><label className="bookstore-check"><input name="consent" type="checkbox" required checked={value.consent} onChange={change} />I agree to be contacted about this application. This does not subscribe me to a newsletter.</label><p>Application details are used to review your request and coordinate a potential collaboration. <Link to="/privacy">Privacy policy</Link></p>{error && <p role="alert" className="bookstore-error">{error}</p>}<button disabled={busy}>{busy ? "Submitting…" : "Send collaboration application"}</button></fieldset></form>}</article>;
}
